import type { Booking } from '#domain/Booking.ts';

import type { ApiBooking } from '../bookingApi.slice.ts';

export const mapBooking = (booking: ApiBooking): Booking => ({
    booking: booking.booking,
    status: booking.status,
});
